import Process from './Process';

export default Process;



// WEBPACK FOOTER //
// ./src/containers/Home/Process/index.js